import React from 'react';
import { Form } from 'react-bootstrap';

function SalesProfileFormFields({ form, on_change, class_prefix = 'sp-wizard' }) {
	return (
		<React.Fragment>
			<div className={class_prefix + '-field'}>
				<Form.Label className={class_prefix + '-label'}>Profile Name</Form.Label>
				<p className={class_prefix + '-hint'}>A short name so you can identify and re-use this profile later.</p>
				<Form.Control
					type="text"
					className={class_prefix + '-input'}
					placeholder="e.g. My CRM Software"
					value={form.name}
					onChange={e => on_change('name', e.target.value)}
				/>
			</div>
			<div className={class_prefix + '-field'}>
				<Form.Label className={class_prefix + '-label'}>Solution Category</Form.Label>
				<p className={class_prefix + '-hint'}>The general category of what you are selling. Keep it broad.</p>
				<Form.Control
					type="text"
					className={class_prefix + '-input'}
					placeholder="e.g. CRM software, IT services, marketing platform"
					value={form.solution_category}
					onChange={e => on_change('solution_category', e.target.value)}
				/>
			</div>
			<div className={class_prefix + '-field'}>
				<Form.Label className={class_prefix + '-label'}>Offering Description</Form.Label>
				<p className={class_prefix + '-hint'}>Describe your specific product or service in detail. The AI prospect will use this to respond to your pitch and ask relevant questions.</p>
				<Form.Control
					as="textarea"
					rows={10}
					className={class_prefix + '-input'}
					placeholder="e.g. A cloud-based CRM platform that helps small businesses track leads, manage follow-ups, and close deals faster - without needing a dedicated IT team."
					value={form.offering_description}
					onChange={e => on_change('offering_description', e.target.value)}
				/>
			</div>
		</React.Fragment>
	);
}

export default SalesProfileFormFields;
